import type {App} from 'vue';
import {defineAsyncComponent} from 'vue';

export function registerGlobalComponents(app: App) {
    app.component('TheHelpLink', defineAsyncComponent(() =>
        import('@/components/widgets/HelpLink.vue')
    ));
    app.component('FwDivider', defineAsyncComponent(() =>
        import('@/components/Global/Fleetify/fw-divider.vue')
    ));
    app.component('FeatureTitle', defineAsyncComponent(() =>
        import('@/components/dashboard/FeatureTitle.vue')
    ));
}
